import {seoText} from './catalog-seo.mjs';
import {profileSectionUrl} from './profile-sections-schema.mjs';
import {servicePage} from './site-seo.mjs';
const sections={
 '':['Профиль садовода','Дневники выращивания, публикации, отзывы и рекорды'],
 grown:['Выращенные сорта','Личный опыт выращивания сортов и оценки растений'],
 favorite:['Избранные сорта','Сорта растений, сохранённые в избранном'],
 reviews:['Отзывы и оценки','Отзывы и оценки растений и производителей'],
 statistics:['Статистика выращивания','Культуры, сезоны и история посевов'],
 achievements:['Достижения','Полученные награды и достижения садовода'],
 records:['Личные рекорды','Рекорды массы плодов с фотографиями'],
 edit:['Редактирование профиля','Настройки личного профиля'],
 settings:['Настройки профиля','Личные настройки садовода']
};
export function profileSeo({path,query={},name='',about='',empty=false}){
 const cleanPath=path.replace(/\/+$/,'');
 const section=cleanPath.split('/')[3]||'';
 let [label,description]=sections[section]||['Профиль садовода','Материалы садовода'];
 if(section==='favorite'&&query.type==='posts'){label='Сохранённые посты';description='Личная коллекция сохранённых публикаций';}
 if(section==='reviews'&&query.type==='brands'){label='Отзывы о производителях';description='Личный опыт садовода о производителях';}
 const person=seoText(name)||'Садовод';
 const summary=section===''&&seoText(about)?person+': '+seoText(about):description+': '+person+'. Сообщество «Умный Огород».';
 return {title:label+' — '+person+' — Умный Огород',description:summary.length>175?summary.slice(0,172).replace(/\s+\S*$/,'')+'…':summary,canonical:profileSectionUrl({id:cleanPath.split('/')[2]},section,query)||'https://uogorod.ru'+cleanPath,noindex:section==='favorite'&&query.type==='posts'||empty||servicePage(cleanPath)||!Object.hasOwn(sections,section)||Object.entries(query).some(([key,value])=>! /^(utm_|gclid$|yclid$|fbclid$)/i.test(key)&&value!=null&&String(value)!=='')};
}
